import { Toast } from "vant";
import {
    personalProdureList,
    wespeechcraftgroupSaveMobile,
    wespeechcraftSave,
    wespeechcraftUpdate,
    wespeechcraftCheck,
} from "@/server/api.js";
import AddFile from "@/views/wegroupsend/addFile";

export default {
    name: "customerGroup",
    components: {AddFile},
    data() {
        return {
            produreName:"",
            messageWord:'',
            id:'',
            produreId:"",//是否新建话术id
            groupId:0,
            group_str:'',
            qWediaAttachmentsDataVos:[],
            isFixedBottoms:true,
            dialogOpen:false,//是否打开选择框
            groupDialog:false, //新建分组弹框
            addGroupName:'',
            showError:false,
            groupNameArr:[],
            required:false,
            textType:{
                linkUrl: "",
                content: "",
                orderNum: "",
                picUrl: "",
                title: "",
                appId: "",
                url: "",
                fileName: "",
                msgType:'text'
            },
            qWediaAttachmentsDataList:[]
        };
    },
    async created() {
        await this.grouplist();
        this.produreId = this.$route.query.id;
        if(this.produreId){
            await this.checkProdure(this.produreId);
        }
    },
    watch:{
        dialogOpen(val){
            let field =  this.$refs.users_field.$el;
            let cell = this.$refs.group_share;
            if(val){
                field.style.display = 'block';
                cell.classList.add('currentOpen');
            }else{
                field.style.display = 'none';
                cell.classList.remove('currentOpen');
            }
        },
        // 'textType.content'(val){
        //     //this.textType.fileName = val;
        // }
    },
    methods: {
        beforeClose(action,done){
            if(action==='confirm'){
                done(false);
            }else{
                done();
            }
        },
        //创建分组确认
        async addNewGroupConfirm(){
            if(this.addGroupName){
                this.groupDialog = false;
                this.showError = false;
                const res = await wespeechcraftgroupSaveMobile({title:this.addGroupName});
                if(res.code != 200) return Toast.fail(res.msg);
                await Toast.success('新建成功');
                await this.grouplist();
            }else{
                this.showError = true;
            }
        },

        listArr(val){
            this.qWediaAttachmentsDataList = [];
            for(let i of val){
                this.qWediaAttachmentsDataList.push(i);
            }
        },

        //分组列表
        async grouplist() {
            let res = await personalProdureList();
            this.loading = false;
            if (res.code !== "200") {
                Toast.fail(res.msg);
                this.finished = true;
                this.finishedtext = res.msg;
                return;
            }
            this.finished = true;
            this.groupNameArr = res.data;
        },

        addNewGroupCancel(){
            this.groupDialog = false;
        },

        formUpdate(){
            let form = this.$refs.form;
            return  form.validate(['groupName','messageWord','produreName']);
        },

        formIsRequire(){
            let form = this.$refs.form;
            return  form.validate(['groupName','produreName']);
        },

        //提交确认
        async ensureComfirm(){
            let isRquForm = null;
            let users_field = this.$refs.users_field.$el;
            if(!this.user_str){
                users_field.style.display = 'block';
            }
            if(this.textType.content){
                this.required = true;
                isRquForm = this.formIsRequire();
            }else if(this.qWediaAttachmentsDataList.length){
                this.required = false;
                isRquForm = this.formIsRequire();
            }else{
                this.required = true;
                isRquForm = this.formUpdate();
            }

            isRquForm.then(async()=>{
                if(this.qWediaAttachmentsDataList.length>0){
                    this.qWediaAttachmentsDataVos.push(...this.qWediaAttachmentsDataList);
                }

                if(this.textType.content){
                    this.qWediaAttachmentsDataVos.push(this.textType);
                }

                let params = {
                    title:this.produreName,
                    groupId:this.groupId,
                    qWediaAttachmentsDataVos:this.qWediaAttachmentsDataVos,
                    id:this.produreId
                }
                console.log(params);
                const res = this.produreId? await wespeechcraftUpdate(params) : await wespeechcraftSave(params);
                if (res.code !== "200") return Toast.fail(res.msg);
                if(res.success){
                    //console.log(res);
                    await this.$router.push({
                        path:'reply',
                        query:{
                            activeTab:'right_produre'
                        }
                    });
                }
            }).catch((err) =>{
                console.log(err);
            });

        },

        //打开选择分组下拉
        openSelect(){
            this.dialogOpen = true;
        },

        //选择下拉选项
        selectGroup(val){
            this.groupId = val.id;
            this.group_str = val.title;
            this.dialogOpen = false;
        },

        //点击添加分组
        creatNewGroup(){
            this.groupDialog = true;
            this.addGroupName = '';
        },

        //编辑模式请求数据回显
        async checkProdure(id){
            this.produreId = Number(id);
            const res = await wespeechcraftCheck({id:this.produreId});
            if(res.code !=="200") return Toast.fail(res.msg);
            // this.messageWord = res.data.content;
            this.produreName = res.data.title;
            this.groupId = res.data.groupId;
            for(let i of  res.data.qWediaAttachmentsDataVos){
                if(i.msgType==='text'){
                    this.textType = {...i};
                }else{
                    this.qWediaAttachmentsDataList.push(i);
                }

            }
            for(let i of this.groupNameArr){
                if(i.id===this.groupId){
                    this.group_str = i.title;
                }
            }
        },

        isFixedBottom(bool){
            this.isFixedBottoms = bool;
        },

        resetUser(){
            this.$router.push({
                path:'reply',
                query:{
                    activeTab:'right_produre'
                }
            });
        },

    }
};
